(function () {
  var pdpLightbox = null;

  var pdpLightboxHtml =
    '<div id="glightbox-body" class="glightbox-container kunjaree-pdp-glightbox">' +
    '<div class="gloader visible"></div>' +
    '<div class="goverlay"></div>' +
    '<div class="gcontainer">' +
    '<div id="glightbox-slider" class="gslider"></div>' +
    '<button class="gnext gbtn" type="button" tabindex="0" aria-label="Next image">{nextSVG}</button>' +
    '<button class="gprev gbtn" type="button" tabindex="1" aria-label="Previous image">{prevSVG}</button>' +
    '<button class="gclose gbtn" type="button" tabindex="2" aria-label="Close gallery">{closeSVG}</button>' +
    '</div>' +
    '</div>';

  function initPdpGallery() {
    if (typeof GLightbox === 'undefined') return;
    if (!document.querySelector('.kunjaree-pdp-lightbox')) return;

    if (pdpLightbox) {
      try {
        pdpLightbox.destroy();
      } catch (e) {
        /* ignore */
      }
      pdpLightbox = null;
    }

    pdpLightbox = GLightbox({
      selector: '.kunjaree-pdp-lightbox',
      lightboxHTML: pdpLightboxHtml,
      touchNavigation: true,
      loop: true,
      zoomable: true,
      draggable: true,
      openEffect: 'fade',
      closeEffect: 'fade',
      slideEffect: 'slide'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpGallery);
  } else {
    initPdpGallery();
  }

  document.addEventListener('shopify:section:load', initPdpGallery);
})();
